import { Layer, Source } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { PLACES_LAYER_STYLE, PLACES_NAME_LAYER_STYLE } from '../../../constants/map';
import { placesGeojsonState } from '../../../storage/places';

export function PlacesLayer() {
  const placesGeojson = useRecoilValue(placesGeojsonState);

  if (!placesGeojson) {
    return null;
  }

  return (
    <Source
      type="geojson"
      data={placesGeojson}
      id="places"
    >
      <Layer {...PLACES_LAYER_STYLE} />
      <Layer {...PLACES_NAME_LAYER_STYLE} />
    </Source>
  );
}
